import React from "react";
import { Box, IconButton } from "@mui/material";
import BackIcon from "@mui/icons-material/ArrowBackIosNew";

function PrevSlideButton(props: {
  prevSlide: () => void;
  height?: string;
  fontSize?: string;
}) {
  return (
    <Box sx={{ position: "relative", top: props.height || "160px" }}>
      <IconButton onClick={props.prevSlide} size="small">
        <BackIcon sx={{ fontSize: props.fontSize || "24px" }} />
      </IconButton>
    </Box>
  );
}

export default PrevSlideButton;
